import _implicitStylesheets from "./providerDetails.css";
import _implicitScopedStylesheets from "./providerDetails.scoped.css?scoped=true";
import _wdsTitledGroup from "wds/titledGroup";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3 type-style="display-6" class="title${0}"${2}>${"t1"}</h3>`;
const $fragment2 = parseFragment`<div class="logo${0}"${2}><img${"a1:src"}${"a1:alt"} role="img"${3}></div>`;
const $fragment3 = parseFragment`<div${3}><div grid axis="column"${3}><div type-style="display-7"${3}>${"t3"}</div><div type-style="display-8"${3}>${"t5"}</div></div></div>`;
const $fragment4 = parseFragment`<div size="1:1 1:2@medium" class="detailsCell${0}"${2}><div type-style="body-3"${3}>${"t2"}</div><div type-style="body-3" class="year${0}"${2}>${"t4"}</div></div>`;
const $fragment5 = parseFragment`<div size="1:1 1:2@medium" class="detailsCell${0}"${2}><div type-style="body-3"${3}>${"t2"}</div><div type-style="body-3"${3}><a${"a4:href"} role="link"${3}>${"t5"}</a></div></div>`;
const $fragment6 = parseFragment`<div size="1:1 1:2@medium" class="detailsCell${0}"${2}><div type-style="body-3"${3}>${"t2"}</div><div type-style="body-3"${3}><a${"a4:href"} role="link"${3}>${"t5"}</a></div></div>`;
const $fragment7 = parseFragment`<div size="1:1 1:2@medium" class="detailsCell${0}"${2}><div type-style="body-3"${3}>${"t2"}</div><span type-style="body-3"${3}>${"t4"}</span></div>`;
const $fragment8 = parseFragment`<p class="provider-description${0}" type-style="body-3"${2}>${"t1"}</p>`;
const stc0 = {
  attrs: {
    "grid": "",
    "axis": "column"
  },
  key: 2
};
const stc1 = {
  classMap: {
    "logoNameRow": true
  },
  attrs: {
    "grid": ""
  },
  key: 3
};
const stc2 = {
  attrs: {
    "grid": "",
    "flow": "wrap"
  },
  key: 8
};
const stc3 = {
  classMap: {
    "detailsCell": true
  },
  attrs: {
    "size": "1:1 1:2@medium"
  },
  key: 9
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, c: api_custom_element} = $api;
  return [$cmp.provider ? api_static_fragment($fragment1, 1, [api_static_part(1, null, api_dynamic_text($cmp.labels.title))]) : null, $cmp.provider ? api_element("div", stc0, [api_element("div", stc1, [$cmp.logo ? api_static_fragment($fragment2, 5, [api_static_part(1, {
    attrs: {
      "src": $cmp.logo,
      "alt": $cmp.logoAlt
    }
  }, null)]) : null, api_static_fragment($fragment3, 7, [api_static_part(3, null, api_dynamic_text($cmp.provider.name)), api_static_part(5, null, api_dynamic_text($cmp.provider.hQLocation))])]), api_element("div", stc2, [$cmp.hasSocialImpact ? api_element("div", stc3, [api_custom_element("wds-titled-group", _wdsTitledGroup, {
    props: {
      "title": $cmp.labels.socialImpact,
      "badges": $cmp.socialImpactBadges,
      "tooltip": $cmp.socialImpactTooltip
    },
    key: 10
  })]) : null, $cmp.hasYearFounded ? api_static_fragment($fragment4, 12, [api_static_part(2, null, api_dynamic_text($cmp.labels.founded)), api_static_part(4, null, api_dynamic_text($cmp.provider.yearFounded))]) : null, $cmp.hasWebsite ? api_static_fragment($fragment5, 14, [api_static_part(2, null, api_dynamic_text($cmp.labels.website)), api_static_part(4, {
    attrs: {
      "href": $cmp.provider.website
    }
  }, null), api_static_part(5, null, api_dynamic_text($cmp.provider.website))]) : null, $cmp.hasEmail ? api_static_fragment($fragment6, 16, [api_static_part(2, null, api_dynamic_text($cmp.labels.email)), api_static_part(4, {
    attrs: {
      "href": $cmp.mailTo
    }
  }, null), api_static_part(5, null, api_dynamic_text($cmp.provider.email))]) : null, $cmp.hasPhoneNumber ? api_static_fragment($fragment7, 18, [api_static_part(2, null, api_dynamic_text($cmp.labels.phone)), api_static_part(4, null, api_dynamic_text($cmp.provider.phoneNumber))]) : null])]) : null, $cmp.provider ? api_static_fragment($fragment8, 20, [api_static_part(1, null, api_dynamic_text($cmp.formattedDescription))]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1kmp4jr0hu1";
tmpl.legacyStylesheetToken = "undefined-_providerDetails";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
